"use client";

import { ArrowRight, Linkedin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EditorialTeam() {
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const leaders = [{
    name: "Elena Rodriguez",
    role: "Editor-in-Chief",
    expertise: "Over 15 years of investigative journalism experience, dedicated to uncovering systemic issues and amplifying marginalized voices.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711113/img/editor_elena_rodriguez.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711113/img/editor_elena_rodriguez.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711113/img/editor_elena_rodriguez.webp-wvc-sizes",
    linkedin: "#",
    profile: "#"
  }, {
    name: "Marcus Thorne",
    role: "Director of Multimedia",
    expertise: "Award-winning producer specializing in immersive storytelling and digital media strategies for community-driven platforms.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711113/img/director_marcus_thorne.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711113/img/director_marcus_thorne.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711113/img/director_marcus_thorne.webp-wvc-sizes",
    linkedin: "#",
    profile: "#"
  }, {
    name: "Sarah Jenkins",
    role: "Community Engagement Lead",
    expertise: "Expert in building inclusive digital spaces and fostering meaningful dialogue between newsrooms and the public.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711113/img/lead_sarah_jenkins.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711113/img/lead_sarah_jenkins.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711113/img/lead_sarah_jenkins.webp-wvc-sizes",
    linkedin: "#",
    profile: "#"
  }, {
    name: "David Chen",
    role: "Lead Data Analyst",
    expertise: "Translates complex datasets into accessible, visual narratives that hold power to account and inform the community.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711113/img/analyst_david_chen.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711113/img/analyst_david_chen.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711113/img/analyst_david_chen.webp-wvc-sizes",
    linkedin: "#",
    profile: "#"
  }, {
    name: "Amara Okafor",
    role: "Senior Investigative Reporter",
    expertise: "Focuses on grassroots stories and social justice, ensuring underrepresented perspectives are at the forefront of our reporting.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711113/img/reporter_amara_okafor.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711113/img/reporter_amara_okafor.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711113/img/reporter_amara_okafor.png-wvc-sizes",
    linkedin: "#",
    profile: "#"
  }, {
    name: "Julian Vane",
    role: "Director of Operations",
    expertise: "Ensures the editorial engine runs with precision, maintaining the highest standards of journalistic integrity and accessibility.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711113/img/director_julian_vane.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711113/img/director_julian_vane.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711113/img/director_julian_vane.webp-wvc-sizes",
    linkedin: "#",
    profile: "#"
  }, {
    name: "Priya Sharma",
    role: "Head of Research",
    expertise: "Leads our fact-checking and research practice, ensuring every story is grounded in verified, unbiased truth.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711113/img/researcher_priya_sharma.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711113/img/researcher_priya_sharma.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711113/img/researcher_priya_sharma.webp-wvc-sizes",
    linkedin: "#",
    profile: "#"
  }, {
    name: "Thomas Wright",
    role: "Chief Strategy Officer",
    expertise: "Guides the platform's mission to build a sustainable, community-owned news ecosystem for the future.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711113/img/strategist_thomas_wright.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711113/img/strategist_thomas_wright.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711113/img/strategist_thomas_wright.webp-wvc-sizes",
    linkedin: "#",
    profile: "#"
  }];
  return <section data-section-id="10836" id="the-editorial-team" className="bg-background text-foreground py-24 md:py-32 font-default">
      <div className="mx-auto max-w-[1440px] px-5 md:px-6 lg:px-12">
        {}
        <div ref={header.ref} className={`grid grid-cols-1 lg:grid-cols-12 gap-x-6 gap-y-10 transition-all duration-500 ease-out ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <div className="lg:col-span-7">
            <div className="text-[0.8125rem] font-medium uppercase tracking-[0.04em] leading-none text-foreground">
              Our People
            </div>
            <h2 className="mt-6 font-semibold leading-[1.02] tracking-[-0.02em] text-foreground" style={{
            fontSize: "clamp(2.25rem, 3.6vw, 3.75rem)"
          }}>
              <span style={{
              color: "var(--chart-1)"
            }}>Journalists</span>
              {", not just observers."}
            </h2>
            <div className={`mt-6 h-px bg-border origin-left transition-transform duration-[520ms] ease-out ${header.isVisible ? "scale-x-100" : "scale-x-0"}`} style={{
            transitionDelay: "80ms"
          }} />
          </div>
          <div className="lg:col-span-5 lg:col-start-8">
            <p className="font-default text-muted-foreground" style={{
            fontSize: "clamp(1.125rem, 1.35vw, 1.375rem)",
            lineHeight: 1.55,
            letterSpacing: "-0.005em"
          }}>
              Inclusive Voices News is powered by a team of dedicated storytellers, 
              researchers, and community advocates. We believe in unbiased truth 
              and the power of diverse perspectives to build a stronger, more 
              informed society.
            </p>
          </div>
        </div>

        {}
        <div className="mt-20 md:mt-24 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border-r border-b border-border">
          {leaders.map((person, i) => <LeaderCell key={person.name} data-index={i} index={i} person={person} />)}
        </div>
      </div>
    </section>;
}
function LeaderCell({
  person,
  index,
  ...rest
}: {
  person: {
    name: string;
    role: string;
    expertise: string;
    image: string;
    srcset: string;
    sizes: string;
    linkedin: string;
    profile: string;
  };
  index: number;
  [key: string]: unknown;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const col = index % 4;
  const row = Math.floor(index / 4);
  const delay = (row * 4 + col) * 60;
  return <div {...rest} ref={ref} className={`group relative border-t border-l border-border transition-all duration-500 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
    transitionDelay: `${delay}ms`
  }}>
      {}
      <span aria-hidden="true" className="pointer-events-none absolute -top-px left-0 right-0 h-0.5 origin-left scale-x-0 transition-transform duration-[220ms] ease-out group-hover:scale-x-100" style={{
      backgroundColor: "var(--chart-1)"
    }} />

      <div className="flex flex-col h-full">
        {}
        <div className="relative w-full overflow-hidden bg-secondary">
          <div className="aspect-[4/5] w-full">
            <img src={person.image} data-wvc-srcset={person.srcset} data-wvc-sizes={person.sizes} alt={person.name} loading="lazy" decoding="async" className="h-full w-full object-cover object-top" style={{
            filter: "grayscale(100%) contrast(1.05)"
          }} />
          </div>
        </div>

        {}
        <div className="flex flex-col flex-1 px-7 pt-6 pb-7">
          <h3 className="font-default font-medium leading-[1.15] text-foreground transition-transform duration-[220ms] ease-out group-hover:-translate-y-2" style={{
          fontSize: "clamp(1.5rem, 1.9vw, 2rem)",
          letterSpacing: "-0.012em"
        }}>
            {person.name}
          </h3>

          <p className="mt-2 font-medium leading-[1.25] text-muted-foreground" style={{
          fontSize: "clamp(1.125rem, 1.3vw, 1.375rem)",
          letterSpacing: "-0.005em"
        }}>
            {person.role}
          </p>

          <div className="mt-4 h-px w-3/5 bg-border" />

          <p className="mt-4 text-muted-foreground" style={{
          fontSize: "0.8125rem",
          lineHeight: 1.4,
          letterSpacing: "0.01em"
        }}>
            {person.expertise}
          </p>

          <div className="mt-6 flex items-end justify-between gap-4 pt-2 mt-auto">
            <Link to={person.profile} className="group/link inline-flex items-center gap-2 text-foreground">
              <span className="relative font-default font-medium" style={{
              fontSize: "0.9375rem",
              letterSpacing: "0.005em"
            }}>
                Bio
                <span aria-hidden="true" className="absolute left-0 right-0 -bottom-1 h-px bg-border transition-all duration-[220ms] ease-out group-hover/link:right-[-8px]" />
                <span aria-hidden="true" className="absolute left-0 -bottom-1 h-px scale-x-0 origin-left transition-transform duration-[220ms] ease-out group-hover/link:scale-x-100" style={{
                right: "-8px",
                backgroundColor: "var(--chart-1)"
              }} />
              </span>
              <ArrowRight className="h-4 w-4 transition-transform duration-[220ms] ease-out group-hover/link:translate-x-2" strokeWidth={1.5} />
            </Link>

            <Button asChild variant="ghost" size="icon" className="h-8 w-8 hover:bg-transparent text-foreground">
              <Link to={person.linkedin} newTab aria-label={`${person.name} on LinkedIn`}>
                <Linkedin className="h-5 w-5" strokeWidth={1.5} />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </div>;
}